export default "__VITE_ASSET__T5_lM$F3__"